import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950 whitespace-nowrap">
              汗汗漫画
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1 overflow-x-auto">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-secondary-100'
                }`}
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Desktop Right */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-secondary-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-secondary-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu Panel */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200/50 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-secondary-100'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-secondary-200/50 my-2"></div>
            <Link
              to="/about"
              className={`flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:bg-secondary-100'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line"></i>
              </span>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;